module.exports = __webpack_public_path__ + "static/media/puerto-rico.ef7664e5.svg";